//API BASE URL:
export const BASE = '//submit.proofreadingmanuscripts.com/';
export const PAYPAL_ENV = 'production';
export const STRIPE_ENV = 'live';



// WEBPACK FOOTER //
// ./src/config/config.js